import React, { Component } from 'react';
import { List, Row, Col } from 'antd';
import { searchAPI } from '../../api/news.js'
import '../../assets/css/common.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

class News extends Component {
	constructor(props) {
		super(props);
		this.state = {
			total: 0,
			pageSize: 10,
			pageNum: 1,
			dataSource: [],
			loading: false,
		}
	}

	componentDidMount() {
		this.ajaxData()
	}

	// 获取表格数据
	ajaxData = () => {
		const { pageSize, pageNum } = this.state;
		this.setState({ loading: true }, () => {
			searchAPI({ page_size: pageSize, page_num: pageNum })
				.then(res => {
					console.log('ajax', res.data.data);
					this.setState({
						dataSource: res.data.data.data,
						total: res.data.data.total,
						loading: false,
					})
					document.body.scrollTop = 0; // For Safari
					document.documentElement.scrollTop = 0;
				})
		})
	}

	// 处理每页条数改变
	handlePageSizeChange = (current, pageSize) => {
		this.setState({ pageSize: pageSize, pageNum: current }, () => {
			this.ajaxData()
		})
	}

	// 处理页码改变
	handlePageNumChange = (pageNum) => {
		this.setState({ pageNum }, () => {
			this.ajaxData()
		})
	}

	render() {
		const { dataSource, total, loading } = this.state;
		return (
			<div style={{ margin: '40px 15%', }}>
				<MyBreadcrumb urls={[
					{ url: '/news', breadcrumbName: '资讯' },
				]} />
				<div className="major-heading module-title" style={{ textAlign: 'left', marginTop: 10, color: '#144db9' }}>资讯</div>
				<div className="auxiliary-text module-subtitle">NEWS</div>
				<List dataSource={dataSource}
					className="list-res"
					bordered size="large"
					locale={{ emptyText: ' ' }} loading={{ tip: "数据加载中 ...", spinning: loading }}
					renderItem={(item, index) => (
						<Row
							className="list"
							style={{ marginTop: 10, color: item.is_top ? 'red' : '#333333', borderBottom: '1px solid #e9e9e9', cursor: 'pointer' }}
							key={index}
							onClick={() => {
								if (item.file_name) {
									window.open(`http://parliament.whu.edu.cn/static/commons/news/${item.file_name}`, '_blank');
								} else {
									window.open(`/news/${item.id}`, '_blank');
								}
							}}
						>
							<Col span={22} className="main-text" style={{ marginLeft: -10, }}>
								<ul>
									<li>
										<span style={{ color: item.is_top ? 'red' : '#333333' }}>{item.title}</span>
									</li>
								</ul>
							</Col>
							<Col span={2}>{item.create_time.split(' ')[0]}</Col>
						</Row>
					)}
					style={{ marginTop: 10, marginLeft: 0, }}
					pagination={{ showQuickJumper: true, total: total, onChange: this.handlePageNumChange, onShowSizeChange: this.handlePageSizeChange, showSizeChanger: true, }}
				/>
			</div>
		);
	}
}

export default News
